import types from "../types";
import {
  showSuccessSnackbar,
  showFailSnackbar,
} from "../../common/actions/snackbar";
import { push } from "../../router/history";

export function editUser(newData){
  return async (dispatch) => {
    return dispatch({
      type: types.UPDATE,
      payload: {
        request: {
          url: "users/update",
          method: "POST",
          data: newData,
        },
      },
    })
    .then(async ({ payload }) => {
      push('user-list')
      dispatch(
        showSuccessSnackbar(
          "Sucesso! O usuário foi editado."
        )
      );
    })
    .catch((error) => {
      console.log("error---", error);
      dispatch(
        showFailSnackbar("Ops! Algo deu errado, tente novamente mais tarde.")
      );
    });

  }
}

export function getUsers() {
  return async (dispatch) => {
    return dispatch({
      type: types.LIST,
      payload: {
        request: {
          url: "users",
          method: "GET",
        },
      },
    })
      .then(async ({ payload }) => {
        const { data } = payload.data;
      })
      .catch((error) => {
        console.log("error---", error);
      });
  };
}
